<script>
	export let row = {};
	export let key = "";
	export let index = 0;

	const url = new URL(window.location.href);
	const pageSize = url.searchParams.get("pageSize") || 20;
	const page = url.searchParams.get("page") || 1;
	const pageNumber = url.searchParams.get("pageNumber") || 1;
</script>

<span>
	{index + pageSize * (pageNumber - 1)}
</span>
